<template>
    <section class="mc-card" aria-labelledby="nc-generation-title">
        <div class="mc-card__head">
            <div>
                <h2 id="nc-generation-title" class="mc-card__title">Generazione ordini da NC</h2>
                <p class="mc-card__sub">Elabora tutte le non conformità in attesa in Sage.</p>
            </div>
            <div class="mc-return-actions__submit">
                <v-btn outlined :loading="loading" :disabled="submitting" @click="loadStatus">
                    <v-icon left>mdi-refresh</v-icon>Aggiorna stato
                </v-btn>
                <v-btn depressed class="mc-return-primary" :disabled="loading || submitting || (!state.can_start && !state.read_only)" @click="confirming = true">
                    <v-icon left>mdi-cog-play-outline</v-icon>Genera ordini da NC
                </v-btn>
            </div>
        </div>
        <mc-state-message v-if="error" state="error" :title="error" @retry="loadStatus" />
        <mc-state-message v-else-if="loading" state="loading" :height="48" />
        <p v-else class="mc-card__sub" role="status" aria-live="polite">{{ state.detail }}</p>
        <v-dialog v-model="confirming" max-width="520" :persistent="submitting">
            <v-card class="mc-root mc-customer-return mc-dialog">
                <div class="mc-dialog__head"><h2 class="mc-dialog__title">Generare gli ordini da NC?</h2></div>
                <div class="mc-dialog__body">
                    <p>Verranno elaborate tutte le NC in attesa, anche di altri clienti. L'operazione può creare ordini di vendita e di riparazione e aggiornare Sage.</p>
                    <p v-if="state.read_only" role="status">{{ state.detail }}</p>
                </div>
                <div class="mc-dialog__foot">
                    <v-btn text :disabled="submitting" @click="confirming = false">Annulla</v-btn>
                    <v-btn depressed class="mc-return-primary" :disabled="!state.can_start || state.read_only" :loading="submitting" @click="submit">Conferma e avvia</v-btn>
                </div>
            </v-card>
        </v-dialog>
    </section>
</template>

<script>
import McStateMessage from "@/assets/mecom/vue/McStateMessage.vue";

const ENDPOINT = "/arts/resi-cliente/generazione-nc/";

export default {
    name: "CustomerReturnGeneration",
    components: { McStateMessage },
    data: () => ({
        state: { can_start: false, read_only: false, detail: "" },
        loading: false,
        submitting: false,
        confirming: false,
        error: "",
    }),
    mounted() {
        this.loadStatus();
    },
    methods: {
        async loadStatus() {
            if (this.loading || this.submitting) return;
            this.loading = true;
            this.error = "";
            this.state.can_start = false;
            try {
                const response = await this.$work.get(ENDPOINT);
                this.state = response.data;
            } catch {
                this.error = "Impossibile verificare lo stato della generazione. Aggiorna lo stato prima di avviare.";
            } finally {
                this.loading = false;
            }
        },
        async submit() {
            if (this.submitting || !this.confirming || !this.state.can_start || this.state.read_only) return;
            this.submitting = true;
            this.error = "";
            this.state.can_start = false;
            try {
                const response = await this.$work.post(ENDPOINT, {
                    request_id: window.crypto.randomUUID(),
                    confirmed: true,
                });
                this.state = response.data;
                this.$toast.info(response.data.detail, { icon: "mdi-information-outline", timeout: 6000 });
            } catch (error) {
                const detail = error.response && error.response.data && error.response.data.detail;
                this.error = detail || "Esito della richiesta non verificabile. Aggiorna lo stato prima di un nuovo avvio.";
            } finally {
                this.submitting = false;
                this.confirming = false;
            }
        },
    },
};
</script>
